module.exports = __webpack_public_path__ + "img/xiaozi_jishu.f5a65da7.svg";